import { TGameData } from '../../../../types';

import Day from '../Day';
import '../Day/style';
import { StyledDayContainer, StyledMobileViewContainer } from './style';

type TMobileViewProps = {
  game: TGameData;
  openBox: () => void;
};

const MobileView = ({ openBox }: TMobileViewProps) => {
  const today = new Date();
  const currentDay = today.getDate().toString();

  return (
    <StyledMobileViewContainer>
      <StyledDayContainer>
        <Day day={currentDay} gridArea="" openBox={openBox} />
      </StyledDayContainer>
    </StyledMobileViewContainer>
  );
};

export default MobileView;
